// Determines optimal text color (black or white) for given background color
// using YIQ color space formula for better readability contrast.
export const getContrastColor = (hexColor) => {
  if (!hexColor) {
    return;
  }
  const color = hexColor.replace('#', '');
  const r = parseInt(color.slice(0, 2), 16);
  const g = parseInt(color.slice(2, 4), 16);
  const b = parseInt(color.slice(4, 6), 16);

  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? '#000000' : '#FFFFFF';
};
